import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';
import { HttpEventType, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { UploadStatus } from '../../models/upload-status';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnChanges {
  @Input() title: string = "Upload Attachment";
  @Input() showIcon: boolean = false;
  @Input() attachmentIcon: string = "fas fa-paperclip fa-vertical fa-2x";
  @Input() acceptedFiles: string;
  @Input() maxFileSizeInMb: number = 2;

  public progress: number;
  public message: string;

  private maxSizeAllowed = 2097152;
  private baseUrl: string = environment.baseApiUrl;

  @Output() public onUploadFinished = new EventEmitter();

  constructor(private http: HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.maxFileSizeInMb =  changes["maxFileSizeInMb"].currentValue as number;

    if(this.maxFileSizeInMb > 0) {
      this.maxSizeAllowed = this.maxFileSizeInMb * 1024 * 1024;
    }
  }

  ngOnInit() {
  }

  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    if(fileToUpload.size > this.maxSizeAllowed) {
      alert(`File size is more than ${this.maxFileSizeInMb}MB. Please choose a smaller file.`);
      return;
    }

    const formData = new FormData();
    formData.append('acceptedFiles', this.acceptedFiles);
    formData.append('file', fileToUpload, fileToUpload.name);

    this.http.post(`${this.baseUrl}/files/upload`, formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event?.total);
        else if (event.type === HttpEventType.Response) {
          this.message = 'Successfully Uploaded';
          const status = new UploadStatus();
          status.success = event.status == 200;
          status.status = this.message;
          status.filePath = event.body["dbPath"];
          this.onUploadFinished.emit(status);
        }
      });
  }
}
